import moment from "moment";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { DateInput, DateTimeInput } from "react-admin";
import "./style.css";
/**
 * @example
 * */

export const CustomDatetime = props => {
  const { showTime, fullWidth, format, ...rest } = props;
  const [isDateChanged, setIsDateChanged] = useState(false);
  const [changedValue, setChangedValue] = useState("");
  // Similar to componentDidMount and componentDidUpdate:
  React.useEffect(() => {
    changeValue((document?.getElementById?.(`${props.source}_id`) as any)?.value);
  });
  const changeValue = tempValue => {
    var value = formatDateTime(tempValue);
    var element: any = document.getElementById(`${props.source}_id`);
    element?.setAttribute?.("data-date", value);
  };
  const formatDateTime = (value: string | Date) => {
    if (value == null || value === "") {
      return showTime ? "dd/mmm/yyyy hh:mm" : "dd/mmm/yyyy";
    }
    var validateValue: string | Date = "";
    if (value instanceof Date) {
      validateValue = value;
    } else {
      validateValue = parseDateTime(value);
    }
    if (validateValue != changedValue && isDateChanged) {
      setIsDateChanged(false);
      if (value instanceof Date) {
        validateValue = value;
      } else {
        validateValue = parseDateTime(value);
      }
    }
    var formatValue = moment(validateValue).format(format || (showTime ? "DD/MMM/yyyy HH:mm" : "DD/MMM/yyyy"));
    return formatValue.toString();
  };
  const parseDateTime = (date: string) => {
    if (isDateChanged) {
      return moment(date).utcOffset(0, false).format();
    } else {
      return moment(date)
        .utcOffset(0, false)
        .add(moment(date).utcOffset() / 60, "hours")
        .format();
    }
  };

  // showTime değerine göre DateInput veya DateTimeInput kullan
  const InputComponent = showTime ? DateTimeInput : DateInput;

  return (
    <InputComponent
      parse={(date: Date) => {
        if (date.toString() === "") {
          return date;
        }
        var newDate = moment(date).utcOffset(0, false).format();
        setIsDateChanged(true);
        setChangedValue(newDate);
        return newDate;
      }}
      style={{ minWidth: 200 }}
      options={{ id: `${props.source}_id` }}
      {...rest}
      {...{ fullWidth: fullWidth }}
    />
  );
};

CustomDatetime.propTypes = {
  format: PropTypes.string,
  showTime: PropTypes.bool,
  fullWidth: PropTypes.bool,
  ...DateInput.prototype,
};

CustomDatetime.defaultProps = {
  format: null,
  showTime: false,
  fullWidth: false,
};

export default CustomDatetime;
